<template>
  <div
    v-click-outside="$_dropdownClose"
    class="dropdown-menu-button-icon"
  >
    <div
      class="dropdown-menu-button"
      :class="{outline: outline, narrow: narrow,subActive:subActive}"
      @click="$_onclick()"
    >
      <i
        v-if="_leadingIcon"
        class="icon leading-icon"
        :class="_leadingIcon"
      />
      <button>
        <p>{{ _computedButtonTextLabel }}</p>
      </button>
      <i
        v-if="outline"
        class="icon trailing-icon outline icon-chevron-up"
        :class="{show: dropdownMenuShow}"
      />
      <i
        v-else-if="!outline && !dropdownMenuShow"
        class="icon trailing-icon icon-arrow-drop-down-circle"
      />
      <i
        v-else-if="!outline && dropdownMenuShow"
        class="icon trailing-icon icon-arrow-drop-up-circle"
      />
    </div>
    <div
      class="dropdown-menu"
      :class="{show: dropdownMenuShow}"
    >
      <perfect-scrollbar class="ps dropdown-scrollable-content">
        <div
          v-for="(menuList_e,menuList_k) in dropdownMenuItem"
          :key="menuList_k"
          class="dropdown-menu-list"
        >
          <div class="menu-list-title">
            <i :class="menuList_e.icon" />
            <p>{{ menuList_e.textLabel }}</p>
          </div>
          <p
            v-for="(item,item_k) in menuList_e.items"
            :key="item_k"
            class="menu-list-item"
            :class="{selected:$_selectedItem(item)}"
            @click="$_selectMenuItem(item)"
          >
            {{ item.textLabel }}
          </p>
        </div>
      </perfect-scrollbar>
    </div>
  </div>
</template>

<script>
import ClickOutside from "vue-click-outside";
export default {
  name: "DropdownMenuButtonIcon",
  directives: {
    ClickOutside,
  },
  props: {
    dropdownMenuItem: {
      type: Array,
      default() {
        return [];
      },
    },
    value: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "",
    },
    leadingIcon: {
      type: String,
      default: "",
    },
    outline: {
      type: Boolean,
      default: false,
    },
    narrow: {
      type: Boolean,
      default: false,
    },
    subActive: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    dropdownMenuShow: false,
  }),
  computed: {
    _computedButtonTextLabel() {
      if (!this.dropdownMenuItem) return;
      if (this.value) {
        let selectedItem = this.value;
        let num = this.$_selectedItemNum(selectedItem);
        let selectedItemTextLabel = this._allItems[num];
        return selectedItemTextLabel ? selectedItemTextLabel.textLabel : "";
      }
      let placeholder = this.placeholder;
      if (placeholder) return placeholder;
      return this.dropdownMenuItem[0] ? this.dropdownMenuItem[0].textLabel : "";
    },
    _allItems() {
      let allItems = [];
      this.dropdownMenuItem.forEach((menuItem) => {
        menuItem.items.forEach((item) => allItems.push(item));
      });
      return allItems;
    },
    _leadingIcon() {
      if (!this.dropdownMenuItem) return;
      let result = [];
      //get menuItems with selectItem in it
      this.dropdownMenuItem.forEach((menuItems) => {
        let selectItem = menuItems.items.some((item) => {
          return item.id === this.value;
        });
        result.push(selectItem);
      });
      //get index of menuItems with selectItem in it
      let menuWithSelectItemIndex = result.indexOf(true);
      if (menuWithSelectItemIndex < 0) return;
      let leadingIcon = this.dropdownMenuItem[menuWithSelectItemIndex].icon;

      return leadingIcon;
    },
  },
  methods: {
    $_onclick() {
      this.$_toggleDropdownMenuShow();
    },
    $_toggleDropdownMenuShow() {
      this.dropdownMenuShow = !this.dropdownMenuShow;
    },
    $_dropdownClose() {
      this.dropdownMenuShow = false;
    },
    $_selectMenuItem(item) {
      this.$emit("input", item.id);
      this.$emit("click", item);
      this.dropdownMenuShow = false;
    },
    $_selectedItem(item) {
      if (this.value == item.id) {
        return true;
      } else {
        return false;
      }
    },
    $_selectedItemNum(select) {
      if (!this.dropdownMenuItem) return;
      if (!select) {
        return;
      }
      let allItems = [];
      this.dropdownMenuItem.forEach((menuItem) => {
        menuItem.items.forEach((item) => allItems.push(item));
      });
      let allId = allItems.map((item) => {
        return item.id;
      });
      let selectedNum = allId.indexOf(select);
      return selectedNum;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/component/dropdown-menu-button-icon";
</style>